import { useMemo, useState } from 'react';
import { SelectProps, Spin } from 'antd';
import { debounce } from 'lodash';

export type PickerOption = {
  /** The display text of the option */
  label: string;
  /** The value of the option */
  value: string;
};

export type PickerValue = PickerOption | PickerOption[] | undefined;

export type PickerProps = Omit<SelectProps, 'mode' | 'notFoundContent'> & {
  /** Specifies that multiple options can be selected at once */
  multiple?: boolean;
  /** Callback on value change of the select element */
  onChange?: (values: PickerValue) => void;
};

export const usePicker = (options?: { defaultSearch?: string }) => {
  const [search, setSearch] = useState(options?.defaultSearch ?? '');
  const onSearch = useMemo(() => debounce(setSearch, 300), []);

  const getSelectProps = (props?: SelectProps): SelectProps => {
    return {
      ...props,
      allowClear: true,
      filterOption: false,
      labelInValue: true,
      loading: props?.loading,
      notFoundContent: props?.loading ? <Spin size="small" /> : null,
      options: [],
      showSearch: true,
      style: { ...props?.style, minWidth: 600 },
      onSearch: (value) => {
        onSearch(value);
        props?.onSearch && props.onSearch(value);
      },
    };
  };

  return { search, getSelectProps };
};
